import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { GoAlert } from "react-icons/go";
function ExitDetectionStatistics() {
  return (
     <Card>
        <CardBody>
            {/* ...............heading.................... */}
            <h2 className='py-3' style={{fontSize:"18px" , fontWeight:"600" ,color:"#1D67AA" }}>Detection Statistics</h2>



            {/* ...............statistics.................... */}

            <div className="d-flex justify-content-between align-items-center py-3">

                <h2 style={{fontSize:"14px", fontWeight:"400", color:"#4B5563"}}>Total Detections</h2>
                <h5 style={{fontSize:"20px", fontWeight:"700" , color:""}}>127</h5>
            </div>
             <div className="d-flex justify-content-between align-items-center py-3">

                <h2 style={{fontSize:"14px", fontWeight:"400", color:"#4B5563"}}>Recognized</h2>
                <h5 style={{fontSize:"20px", fontWeight:"700" , color:"#16A34A"}}>124</h5>
            </div>
             <div className="d-flex justify-content-between align-items-center py-3">

                <h2 style={{fontSize:"14px", fontWeight:"400", color:"#4B5563"}}>Unknown</h2>
                <h5 style={{fontSize:"20px", fontWeight:"700" , color:"#DC2626"}}>3</h5>
            </div>
             <div className="d-flex justify-content-between align-items-center py-3">

                <h2 style={{fontSize:"14px", fontWeight:"400", color:"#4B5563"}}>Confidence</h2>
                <h5 style={{fontSize:"20px", fontWeight:"700" , color:"#1D67AA"}}>98.8%</h5>
            </div>

            <div className="">
                <Card>
                    <CardBody style={{backgroundColor:"#FEFCE8", borderRadius:"8px", border:"1px solid #FEF08A"}}>
                        <div className="d-flex align-items-center gap-2 justify-content-center py-3">
                            <GoAlert    style={{  fontSize:"30px", color:" #CA8A04 "}} />
                            <div >
                                <h5 className='ellipsis-text' style={{fontSize:"20px" , fontWeight:"500", color:"#854D0E", margin:"0px"}}> Unknown Detection</h5>
                                <p style={{fontSize:"20px" , fontWeight:"400", color:"#CA8A04" ,lineHeight:"15px"}}>3 minutes ago</p>
                            </div>
 
                        </div>
                        
                    </CardBody>
                </Card>

            </div>
            

        </CardBody>
    </Card>
  )
}

export default ExitDetectionStatistics